import { atom, useAtom } from 'jotai';

const buildingIdAtom = atom<number | null>(null);

export const useBuildingIdAtom = () => useAtom(buildingIdAtom);
